import { createFileRoute } from "@tanstack/react-router";

import { Address } from "/src/routes/settings/General";

export const Route = createFileRoute("/_main/settings/address")({
  component: Address,
});
